module.exports = __webpack_public_path__ + "assets/7c6503ca7b2e2c312b81a93954d1bca1.png";